import React from 'react';

import Dropdown from 'components/cosmos/dropdown';
import { ReactComponent as ArrowRight } from 'components/svg/icons/arrow-right.svg';
import { ReactComponent as BellCosmos } from 'components/svg/icons/bell-lg.svg';
import { ReactComponent as CalendarPlusIcon } from 'components/svg/icons/calendar-plus.svg';
import { ReactComponent as DeleteIcon } from 'components/svg/icons/delete-lg.svg';
import { ReactComponent as PublishIcon } from 'components/svg/icons/publish.svg';
import { ReactComponent as UnpublishIcon } from 'components/svg/icons/unpublish.svg';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { SELECTOR } from './constants';

import PublishAndNotifyButton from '../PublishAndNotifyButton';

const MassSelector = ({
  toogle,
  transition,
  publish,
  publishAndNotify,
  unpublish,
  exclude,
  disablePublish,
  disableUnpublish,
  updateWizardState
}) => {
  const ITEMS = [
    {
      key: 0,
      onClick: (e) => {
        e.stopPropagation();
        publish();
        toogle();
      },
      icon: <PublishIcon />,
      label: <I18n label="general.publish" />,
      disabled: disablePublish
    },
    {
      key: 1,
      onClick: (e) => {
        e.stopPropagation();
        publishAndNotify();
        toogle();
      },
      icon: <BellCosmos className="bell-icon" />,
      disabled: disablePublish,
      label: <PublishAndNotifyButton />,
      hidden: !publishAndNotify
    },
    {
      key: 2,
      onClick: (e) => {
        e.stopPropagation();
        unpublish();
        toogle();
      },
      icon: <UnpublishIcon />,
      label: <I18n label="general.unpublish" />,
      disabled: disableUnpublish
    },
    {
      key: 3,
      onClick: (e) => {
        e.stopPropagation();
        updateWizardState && updateWizardState(SELECTOR);
        transition(SELECTOR);
      },
      icon: <CalendarPlusIcon />,
      label: <I18n label="general.schedule" />,
      hasSelectorIcon: true
    },
    {
      key: 4,
      onClick: (e) => {
        e.stopPropagation();
        exclude();
        toogle();
      },
      icon: <DeleteIcon />,
      label: <I18n label="general.exclude" />
    }
  ];

  return (
    <>
      {ITEMS.filter((item) => !item.hidden).map((item) => (
        <Dropdown.MenuItem
          className="ca-scheduler__menu-item _pl-5 _pr-5"
          key={item.key}
          onClick={item.onClick}
        >
          <span className="ca-scheduler__item">
            <span className="ca-scheduler__item__icon">
              {item.icon}
              <p
                data-test="ca-selector-label"
                className="ca-scheduler__label ca-scheduler__item__icon__label"
              >
                {item.label}
              </p>
            </span>
            {item.hasSelectorIcon && <ArrowRight />}
          </span>
        </Dropdown.MenuItem>
      ))}
    </>
  );
};

MassSelector.propTypes = {
  toogle: PropTypes.func,
  transition: PropTypes.func,
  publish: PropTypes.func,
  publishAndNotify: PropTypes.func,
  unpublish: PropTypes.func,
  exclude: PropTypes.func,
  disableUnpublish: PropTypes.bool,
  disablePublish: PropTypes.bool,
  updateWizardState: PropTypes.func
};

export default MassSelector;
